export default {
  userAnalyze: {
    accesses: {
      perPage: 16,
    },
  },
};
